"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractConstraintConverter_1 = require("./AbstractConstraintConverter");
/**
 * RangeConstraintConverter.
 *
 * @author RV
 */


var RangeConstraintConverter =
/*#__PURE__*/
function (_AbstractConstraintCo) {
  _inherits(RangeConstraintConverter, _AbstractConstraintCo);

  function RangeConstraintConverter() {
    _classCallCheck(this, RangeConstraintConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(RangeConstraintConverter).apply(this, arguments));
  }

  return RangeConstraintConverter;
}(AbstractConstraintConverter_1.AbstractConstraintConverter);

exports.RangeConstraintConverter = RangeConstraintConverter;